/**
 * Auth hook — bridges the auth store and API for components.
 * Auth is bootstrapped once by AuthInitializer at app root.
 */
import { useAuthStore } from "../store";
import { authApi } from "../api";
import { isAdminUser } from "../lib/role";

export function useAuth() {
  const { user, isLoading, providers, clearUser } = useAuthStore();

  const isAuthenticated = !!user;
  const isAdmin = isAdminUser(user);

  /** Redirect to OAuth provider for login */
  function loginWith(providerId: string): void {
    window.location.href = authApi.getOAuthUrl(providerId);
  }

  /** Log out and clear local state */
  async function logout(): Promise<void> {
    await authApi.logout();
    clearUser();
  }

  return {
    user,
    isLoading,
    isAuthenticated,
    isAdmin,
    providers,
    loginWith,
    logout,
  };
}
